import React from "react";
import Modal from "react-modal";
import { CrossModal } from "./Icon/CrossModal";

// Set the root element for accessibility
Modal.setAppElement("#root");

const VideoModal = ({ isOpen, onClose, videoUrl }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                overlay: {  
                    backdropFilter: "blur(5px)", 
                    zIndex:1000,
                    backgroundColor: "rgba(255, 255, 255, 0.4)" 
                }
                    ,
                content: {
                    
                    top:'10%',
                    width: "60%",
                    height: "90%",
                    margin: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap:'90px',
                    background:'transparent',
                    border: "none",
                    
                    
                }
            }}
        >
            {/* Close Button */}
           <div style={{display:'flex',justifyContent:'flex-end',}}>
                       <button 
                           onClick={onClose} 
                           style={{
                               position: "absolute", 
                               width:56,
                               background:"rgba(255, 255, 255, 1)",
                               borderRadius:'64px',
                               height:56,
                               
                               border: "none", 
                               // padding: "5px 10px",
                               cursor: "pointer",
                               
           
                           }}
                       >
                           <CrossModal/>
                       </button>
                       </div>

            {/* YouTube Video Embed */}
            <iframe 
                width="100%" 
                height="491px" 
                src={videoUrl} 
                title="YouTube video player" 
                frameBorder="0" 
                allow="autoplay; encrypted-media" 
                allowFullScreen
            ></iframe>
        </Modal>
    );
};

export default VideoModal;
